import { ResourceGroupParentChildPairFragment } from '@/shared/types/types.generated';

export const createGroupAncestryChecker = (
  groups?: ResourceGroupParentChildPairFragment[],
) => {
  if (!groups) {
    return;
  }

  const parentMap = new Map<string, string>();

  for (const group of groups) {
    if (group.parentGroupId) {
      parentMap.set(group.groupId, group.parentGroupId);
    }
  }

  return {
    isChildOf: (parentGroupId: string, childGroupId?: string): boolean => {
      if (!childGroupId) {
        return false;
      }

      let currentId: string | undefined = childGroupId;

      while (currentId) {
        const parent = parentMap.get(currentId);
        if (parent === parentGroupId) {
          return true;
        }
        currentId = parent;
      }

      return false;
    },
  };
};
